import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { Box, Typography } from '@mui/material';
import { alturaContainer } from 'utils/constants';
import { fetchGrillaEspectaculos } from 'utils/redux/features/espectaculosGrillaSlice';
import PageContainer from 'components/PageContainer/PageContainer';
import GrillaEspectaculos from '../../components/public/GrillaEspectaculos/GrillaEspectaculos';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';

const Galeria = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { grillaEspectaculos, loadingGrillaEspectaculos, errorGrillaEspectaculos } = useSelector(
    (state: RootState) => state.espectaculosGrilla
  );
  const espectaculosConGaleria = grillaEspectaculos.filter(e => e.TieneFotos);

  useEffect(() => {
    dispatch(fetchGrillaEspectaculos());
  }, [dispatch]);

  return (
    <PageContainer marginBottom={false}>
      <Box sx={{ minHeight: alturaContainer }}>
        {loadingGrillaEspectaculos ? (
          <Spinner />
        ) : !errorGrillaEspectaculos ? (
          espectaculosConGaleria.length > 0 ? (
            <GrillaEspectaculos
              titulo="Archivo de fotos de espectáculos"
              elementos={espectaculosConGaleria}
              path="galeria"
              textoBoton="Ver fotos"
              mostrarFechas={false}
            />
          ) : (
            <Box textAlign="center" my={3}>
              <Typography variant="h6" mb={3}>
                ¡Excúlpanos!
              </Typography>
              <Typography variant="h6" fontSize={'1rem'}>
                Actualmente no tenemos archivos de fotos en la galería.
              </Typography>
            </Box>
          )
        ) : (
          <NoResponse />
        )}
      </Box>
    </PageContainer>
  );
};

export default Galeria;
